module.exports = __webpack_public_path__ + "static/media/logingraphic.ec029b5e.png";